///////////////////////////////////////////////////////////////////////////////

export const parseTextFilter = (text: string, replaceHyphen = false) => {
  const uuid = text.match(
    /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/
  )?.[0]

  if (replaceHyphen) {
    text = text.replace(/-/g, ' ')
  }

  const query = text
    .replace(/[^\w\s-]+/g, '*') // Replace non-English letters with *
    .replace(/([^*\s])(?:\s+|$)/g, '$1* ') // Add * at end of word if there's none yet
    .match(/[^ ]+/g) // Split words
    ?.filter(e => (uuid ? e !== `${uuid}*` : e)) // Remove uuid
    .join(' AND ')

  return {uuid, query}
}
